import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import { Layout } from "./Layout";
import { SignInPage } from "./pages/SignIn";
import { FlagsListPage } from "./pages/FlagsList";
import { FlagNewPage } from "./pages/FlagNew";
import { FlagDetailPage } from "./pages/FlagDetail";
import { SegmentsListPage } from "./pages/Segments/SegmentsList";
import { SegmentDetailPage } from "./pages/Segments/SegmentDetail";
import { SdkKeysPage } from "./pages/SdkKeys";
import { AuditLogPage } from "./pages/AuditLog";
import { EvaluatePage } from "./pages/Evaluate";
import { ImpressionsPage } from "./pages/Impressions";
import { WorkspaceEnvProvider } from "./state/WorkspaceEnvContext";

export function App() {
  const { loading, identity } = useAuth();

  if (loading) {
    return (
      <div className="sign-in-screen">
        <p className="muted">Loading…</p>
      </div>
    );
  }

  if (!identity) {
    return <SignInPage />;
  }

  return (
    // Keyed on the session's vendor so switching vendor reloads workspaces.
    <WorkspaceEnvProvider key={identity.vendorId ?? ""}>
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/flags" replace />} />
          <Route path="/flags" element={<FlagsListPage />} />
          <Route path="/flags/new" element={<FlagNewPage />} />
          <Route path="/flags/:flagKey" element={<FlagDetailPage />} />
          <Route path="/segments" element={<SegmentsListPage />} />
          <Route path="/segments/:name" element={<SegmentDetailPage />} />
          <Route path="/keys" element={<SdkKeysPage />} />
          <Route path="/audit" element={<AuditLogPage />} />
          <Route path="/evaluate" element={<EvaluatePage />} />
          <Route path="/impressions" element={<ImpressionsPage />} />
          <Route path="*" element={<Navigate to="/flags" replace />} />
        </Routes>
      </Layout>
    </WorkspaceEnvProvider>
  );
}
